// modules
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import DocumentTitle from 'react-document-title';
import axios from 'axios';
// assets
import { externalAccessRoutes } from 'assets/routes';
import { compareById } from 'assets/utils';
import { redirect } from 'utils';
// styles
import { Loader } from 'semantic-ui-react';
// components
import ExternalAccessCourseLesson from './Lesson';
import ExternalAccessCourseVisualization from './Visualization';
// redux
import { setCurrentCourse, setCurrentLessonProgress } from 'store/UI';

class ExternalAccessCourse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            course: {},
            innerWidth: window.innerWidth,
        };
    }

    componentDidMount() {
        const courseId = this.props.match.params.courseId;
        const searchParams = new URLSearchParams(this.props.location.search);
        const accessToken = searchParams.get('accessToken');

        this.fetchCourse(courseId, accessToken);
    }

    handleProgress = (currentBlock, numBlocks) => {
        // update global UI state with current lesson progress
        const progress = Math.floor(((currentBlock + 1) / numBlocks) * 100);
        this.props.setCurrentLessonProgress(progress);
    };

    fetchCourse = async (courseId, accessToken) => {
        this.setState({ loading: true });

        // fetch course
        const response = await axios.get(externalAccessRoutes.fetchCourse(courseId, accessToken)).catch(error => {
            console.error('Error fetching course:', error);
            alert('Ошибка доступа к курсу');
            redirect(this, '/')
            throw error;
        });

        // parse course response
        const course = response.data.message;

        // build list of lessons
        const lessons = course.lessons
            .map((lesson) => ({
                isAvailable: true,
                id: lesson.id,
                section: lesson.section,
                name: lesson.name,
                displayName: lesson.displayName,
                to: `/external-access/courses/${courseId}/lessons/${lesson._id}?accessToken=${accessToken}`,
            }))
            .sort(compareById);

        // build list of lesson keywords
        const lessonKeywords = lessons.map(item => ({
            _id: item._id,
            id: item.id,
            title: `${item.section}. ${item.name}`,
            keywords: item.keywords,
        }));

        // set current course
        const currentCourse = {
            ...course,
            link: `/external-access/courses/${courseId}?accessToken=${accessToken}`,
            lastLesson: null,
            lessons, lessonKeywords
        };
        this.props.setCurrentCourse(currentCourse);

        // set data to state
        this.setState({
            loading: false,
            course: course,
        });
    };

    render() {
        const { t } = this.props;

        return (
            <DocumentTitle title={t('dashboard.externalAccess.course.title')}>
                <div>
                    {this.state.loading ? (
                        <Loader active size='large' />
                    ) : (
                        <Switch>
                            <Route
                                exact
                                path='/external-access/courses/:courseId'
                                render={() => <ExternalAccessCourseVisualization />}
                            />
                            <Route
                                exact
                                path='/external-access/courses/:courseId/lessons/:lessonId'
                                render={() => <ExternalAccessCourseLesson handleProgress={this.handleProgress} innerWidth={this.state.innerWidth} />}
                            />
                            <Redirect to='/' />
                        </Switch>
                    )}
                </div>
            </DocumentTitle>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    setCurrentCourse: currentCourse => dispatch(setCurrentCourse(currentCourse)),
    setCurrentLessonProgress: progress => dispatch(setCurrentLessonProgress(progress))
});

export default withRouter(
    compose(
        connect(null, mapDispatchToProps),
        withTranslation(),
    )(ExternalAccessCourse)
);
